import * as React from "react";
import type { SVGProps } from "react";
const SvgIconRewindClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#clip0_6351_84522)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.23.82C8.54 1 6 2.16 4.08 4.08q-.8.8-1.4 1.69L2.54 6l-.01-1.06c-.01-.64-.03-1.1-.04-1.14-.09-.25-.3-.47-.52-.56-.2-.07-.5-.06-.67.03s-.34.26-.42.42l-.07.14v4.39l.07.15q.14.28.44.43l.14.07h2.1c2.18.01 2.29 0 2.48-.09.13-.06.3-.24.37-.38.1-.19.1-.48.03-.68-.09-.23-.3-.44-.56-.53-.04-.01-.47-.03-1.05-.04l-.98-.01.19-.3c1.4-2.15 3.65-3.68 6.14-4.15.72-.14.93-.16 1.83-.16s1.13.02 1.84.16c.84.17 1.54.4 2.35.8.97.48 1.75 1.04 2.52 1.8.77.77 1.32 1.55 1.8 2.52.4.8.63 1.51.8 2.35.14.71.16.94.16 1.84s-.02 1.13-.16 1.84c-.17.84-.4 1.54-.8 2.35-.48.97-1.04 1.75-1.8 2.52-.77.77-1.55 1.32-2.52 1.8-.98.48-1.86.75-2.95.9-.45.06-1.5.09-1.99.05-3.54-.29-6.6-2.5-8-5.78-.15-.34-.3-.8-.42-1.24-.11-.41-.18-.56-.32-.68q-.23-.2-.51-.22-.46-.04-.74.33c-.21.25-.23.5-.08 1.04.6 2.23 1.88 4.23 3.64 5.7 3.39 2.81 8.1 3.4 12.04 1.48 1.18-.57 2.14-1.25 3.06-2.17 1.62-1.62 2.7-3.69 3.1-5.92.43-2.35.1-4.73-.93-6.86-.57-1.18-1.25-2.14-2.17-3.06q-1.93-1.92-4.55-2.77c-1.29-.4-2.75-.58-4.14-.5m.55 4.78c-.32.1-.56.35-.62.68-.03.2-.03 5.68 0 5.88q.04.25.24.44c.14.14.26.2.46.24.1.02.8.02 2.23.02 1.9 0 2.08-.01 2.18-.05.23-.1.44-.3.52-.53.05-.13.05-.43 0-.56-.08-.23-.29-.44-.52-.53-.1-.04-.26-.04-1.76-.05h-1.65V8.77c0-1.6 0-2.4-.02-2.5-.07-.4-.4-.68-.79-.7q-.15 0-.27.02"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6351_84522">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconRewindClock;
